// Angular
import { Injectable } from '@angular/core';

// Ngrx
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as signup from '../signup/signup.actions';

// Rxjs
import { Observable, of } from 'rxjs';

// Services
import { SoledadAuthenticationService } from '../../../shared/services/b2b/auth.service';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class SignupEffects {
    doSignup$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(signup.signupActionTypes.DO_SIGNUP),
            switchMap((action: signup.DoSignup) =>
                this.authService.newUser(action.payload).pipe(
                    map((data) => new signup.DoSignupSuccess(data)),
                    catchError((error) => of(new signup.DoSignupFail(error)))
                )
            )
        )
    );

    constructor(private authService: SoledadAuthenticationService, private actions$: Actions) {}
}
